import { render, staticRenderFns } from "./roleFuncMgmt.vue?vue&type=template&id=0541d2a7&scoped=true&"
import script from "./roleFuncMgmt.vue?vue&type=script&lang=js&"
export * from "./roleFuncMgmt.vue?vue&type=script&lang=js&"
import style0 from "./roleFuncMgmt.vue?vue&type=style&index=0&id=0541d2a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0541d2a7",
  null
  
)

export default component.exports